module.exports = __webpack_public_path__ + "img/6.677decfe.png";